// AUTO-GENERATED by scripts/gen-content-meta.ts — do not edit by hand.
export const EN_SERVICE_PAIRS: Record<string, string> = {
  "notary-public-english": "notary-public",
  "translation-certified-all": "certified-translation",
  "mfa-consular-en": "mfa-legalization",
  "marriage-service": "marriage-thailand",
  "visa-ltr": "long-term-visas",
  "police-clearance-intl": "police-clearance",
  "thai-visa": "dtv-visa",
  "notary-apostille-poa": "apostille-poa",
  "work-permit": "work-permit",
  "sworn-france": "sworn-translation-eu",
  "company-registration": "company-registration",
  "immigration-tm30-90day": "tm30-90day-reporting",
  "will-inheritance": "will-inheritance",
  "property-conveyancing": "property-conveyancing",
  "visa-smart": "smart-visa",
  "visa-retirement-o": "retirement-visa",
  "expat-bank-account": "bank-account-opening",
  "boi-application": "boi-application",
  "driver-license-conversion": "thai-driving-license",
  "marriage-abroad": "marriage-abroad-hub",
  "expat-relocation-package": "expat-relocation-phuket",
  "notary-e-signature": "notary-e-signature",
  "medical-concierge": "medical-concierge-phuket",
  "us-treaty-amity": "us-treaty-of-amity",
  "notary-poa-cross-border": "property-sale-poa-us",
  "trademark-madrid": "trademark-madrid-protocol",
  "police-clearance-usa": "fbi-background-check-thailand",
  "apostille-thailand-2026": "hague-apostille-2026"
};

export function getEnSlugForThaiSlug(thaiSlug: string): string | undefined {
  return EN_SERVICE_PAIRS[thaiSlug];
}
